<div class="d-flex flex-row align-items-center" *ngIf="isClientRoute() && currentClient">
  <div class="d-flex align-items-center">
    <div ngbDropdown class="d-inline-block">
      <a
        type="button"
        class="btn btn-outline-primary py-2"
        routerLinkActive="active"
        id="clientDropdoen"
        ngbDropdownToggle
      >
        {{ currentClient.name }}
      </a>
      <div ngbDropdownMenu aria-labelledby="clientDropdoen">
        <button ngbDropdownItem class="text-success">
          {{ currentClient.name }}
        </button>
        <hr class="dropdown-divider" />
        <button
          ngbDropdownItem
          *ngFor="let client of clients"
          (click)="selectClient(client)"
        >
          {{ client.name }}
        </button>
        <hr class="dropdown-divider" />
        <button ngbDropdownItem class="text-primary" (click)="addClient()">
          Add client
        </button>
      </div>
    </div>
  </div>

  <div class="ms-4">
    <ul class="nav nav-tabs nav-line-tabs border-0 fs-5">
      <li class="nav-item">
        <a 
          class="nav-link py-2 px-4 d-flex align-items-center" 
          [ngClass]="{'active fw-bold': router.url.includes('/client/stores')}"
          (click)="navigateTo('stores')"
        >
          <span class="nav-icon me-2">
            <app-keenicon name="shop" class="fs-5"></app-keenicon>
          </span>
          <span class="nav-text">Stores</span>
        </a>
      </li>
      <li class="nav-item">
        <a 
          class="nav-link py-2 px-4 d-flex align-items-center" 
          [ngClass]="{'active fw-bold': router.url.includes('/client/webhooks')}"
          (click)="navigateTo('webhooks')"
        >
          <span class="nav-icon me-2">
            <app-keenicon name="webhook" class="fs-5"></app-keenicon>
          </span>
          <span class="nav-text">Webhook Subscription</span>
        </a>
      </li>
    </ul>
  </div>
</div>

<div class="menu-item me-lg-1" *ngIf="!isClientRoute()">
  <a
    class="menu-link py-3 btn btn-outline-secondary"
    routerLink="/client/stores"
    routerLinkActive="active"
  >
    <span class="menu-title">
      <app-keenicon name="shop" class="fs-2"></app-keenicon>
    </span>
  </a>
</div>
